import axios from 'axios';
import Vue from 'vue'
import VueX from 'vuex';
import App from './App.vue'
import './assets/tailwind.css'
import environment from './config/env';
import PortalVue from 'portal-vue';
Vue.config.productionTip = false

Vue.use(PortalVue);
//Automatic Component Import
const files = require.context('./', true, /.*\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

let FEATURED_SUPPLIERS = [
    // 'British Gas',
    // 'EON',
    // 'EDF',
    // 'Npower',
    // 'ScottishPower',
    // 'SSE',
];

let NUMBER_OF_DAYS = [
    '21', '20', '19', '18', '17', '16', '15', '14', '13', '12', '11', '10', '9', '8', '7', '6', '5',
];

Vue.use(VueX)

const API_URL = `${environment.BASE_URL}/api`;
const OTP_API_URL = `${environment.OTP_URL}/api/OTP`;

const URLS = {
    TOKEN: `${API_URL}/token`,
    SUPPLIERS: `${API_URL}/supplier`,
    TARIFFS: `${API_URL}/tariff`,
    BENEFITS: `${API_URL}/benefit`,
    PAYMENT_TYPES: `${API_URL}/PaymentType`,
    REGION: `${API_URL}/postcoderegion`,
    QUOTE: `${API_URL}/QuoteTariff`,
    EMAIL: `${API_URL}/email`,
    QUOTE_FINAL: `${API_URL}/quote`,
    REGIONS: `${API_URL}/postcoderegion`,
    DEFAULTNUMBEROFDAYS: `${API_URL}/defaultnumberofdays`,
    SENDOTP: `${OTP_API_URL}/GenerateOTP`,
    VERIFYOTP: `${OTP_API_URL}/VerifyOTP`,
    GENERATETWITOKEN: `${OTP_API_URL}/GenerateToken`,
}
let request_status = { submitting: false };

const store = new VueX.Store({
    state: {
        form: {
            post_code: null,
            consent_to_pay: false,
            fuel_type: null,
            meter_type: null,
            supplier_id: null,
            gas_payment_type_id: null,
            electricity_payment_type_id: null,
            payment_type: null,
            dual_tariff: null,
            gas_tariff: null,
            electric_tariff: null,
            economy7Percentage: 58,
            want_smart_meter: false,
            interestedElectricSmartMeter: false,
            gas_usage_period: 'Week',
            electricity_usage_period: 'Week',
            electricitySpend: null,
            gasUsage: null,
            electricityUsage: null,
            number_of_days: 5,
            gasSpend: null,
            age: {
                day: null,
                month: null,
                year: null
            },
            selected_address: null,
            title: null,
            source: 'unknown'
        },
        auth: {
            token: null,
        },
        suppliers: {
            all: [],
            fetched: false,
            fetching: false,
        },
        payment_types: {
            all: [],
            fetched: false,
            fetching: false,
        },
        gas_tariffs: {
            all: [],
            fetched: false,
            fetching: false,
        },
        electric_tariffs: {
            all: [],
            fetched: false,
            fetching: false,
        },
        dual_tariffs: {
            all: [],
            fetched: false,
            fetching: false,
        },
        number_of_days: { data: null },
        region: null,
        quotes: null,
        benefits: [],
        form_success: null,
    },
    mutations: {
        setToken(state, payload) {
            Vue.set(state.auth, 'token', payload);
        },

        setSuppliers(state, payload) {
            let final = payload.filter((p) => p.name !== "E")
            Vue.set(state.suppliers, 'all', final);
        },

        setPaymentTypes(state, payload) {
            Vue.set(state.payment_types, 'all', payload);
        },

        setRegion(state, payload) {
            Vue.set(state, 'region', payload);
        },
        setDefaultNumberOfDays(state, payload) {
            // console.log(payload);
            Vue.set(state.number_of_days, 'data', payload);
        },
        setGasTariffs(state, payload) {
            Vue.set(state.gas_tariffs, 'all', payload);
        },
        setElectricTariffs(state, payload) {
            Vue.set(state.electric_tariffs, 'all', payload);
        },
        setDualTariffs(state, payload) {
            Vue.set(state.dual_tariffs, 'all', payload);
        },
        setQuotes(state, payload) {
            Vue.set(state, 'quotes', payload);
        },
        setBenefits(state, payload) {
            Vue.set(state, 'benefits', payload);
        },
        setFormSource(state, payload) {
            Vue.set(state.form, 'source', payload);
        },
    },

    actions: {
        getToken(context, payload) {
            return axios.get(URLS.TOKEN).then(response => {
                context.commit('setToken', response.data);
            }).catch(error => {
                handleError(error, 'getToken', payload);
            });
        },

        getDefaultNumberOfDays(context, payload) {
            return axios.get(URLS.DEFAULTNUMBEROFDAYS, context.getters.request_params()).then(response => {
                context.commit('setDefaultNumberOfDays', response.data.Result);
            }).catch(error => {
                // handleError(error, 'getDefaultNumberOfDays', payload);
            });
        },

        getTwiToken(context, payload) {
            return axios.get(URLS.GENERATETWITOKEN, context.getters.request_params()).then(response => {
                return response.data.token;
            }).catch((e) => {
                console.log(e);
            });
        },

        sendOTP(context, payload) {
            const params = {
                contactNumber: payload.telePhone,
                twiToken: payload.twiToken
            };
            return axios.post(URLS.SENDOTP, params, context.getters.request_params())
                .then(response => {
                    console.log(response.data);
                    return response.data;
                }).catch((e) => {
                    console.log(e)
                });
        },

        verifyOTP(context, payload) {
            const params = {
                contactNumber: payload.phone_number,
                otp: payload.OTP,
            };
            return axios.get(URLS.VERIFYOTP, context.getters.request_params(params))
                .then(response => {
                    return response.data;
                }).catch(error => {
                    console.log("verifyOTPError ", error); // Log detailed error to console
                });
        },
        getSuppliers(context, payload) {
            return axios.get(URLS.SUPPLIERS, context.getters.request_params()).then(response => {
                // console.log(response);
                context.commit('setSuppliers', response.data.Result.suppliers);
            }).catch(error => {
                handleError(error, 'getSuppliers', payload);
            });
        },

        getPaymentTypes(context, payload) {
            return axios.get(URLS.PAYMENT_TYPES, context.getters.request_params()).then(response => {
                context.commit('setPaymentTypes', response.data.Result.paymentTypes);
            }).catch(error => {
                handleError(error, 'getPaymentTypes', payload);
            });
        },

        getRegion(context, postcode) {
            return axios.get(URLS.REGION, context.getters.request_params({ Postcode: postcode })).then(response => {
                context.commit('setRegion', response.data.Result.region);
            }).catch(error => {
                handleError(error, 'getRegion', postcode);
            });
        },

        getQuotes(context, form) {
            return axios.post(URLS.QUOTE, form, context.getters.request_params()).then(response => {
                context.commit('setQuotes', response.data.Result.quotetariffs);
                context.dispatch('getBenefits');
            }).catch(error => {
                handleError(error, 'getQuotes', form);
            });
        },

        getBenefits(context, payload) {
            return axios.get(URLS.BENEFITS, context.getters.request_params()).then(response => {
                context.commit('setBenefits', response.data.Result.benefits);
            }).catch(error => {
                handleError(error, 'getBenefits', payload);
            });
        },

        getGasTariffs(context, details) {
            let params = {
                supplier_id: details.supplier_id || context.state.form.gas_supplier.id,
                region_id: details.region_id || context.state.region.region_id,
                payment_type: details.payment_type || context.state.form.payment_type.id,
            }
            return axios.get(URLS.TARIFFS, context.getters.request_params(params)).then(response => {
                context.commit('setGasTariffs', response.data.Result.tariffs);
            }).catch(error => {
                handleError(error, 'getGasTariffs', details);
            });
        },
        getElectricTariffs(context, details) {
            let params = {
                supplier_id: details.supplier_id,
                region_id: details.region_id,
                payment_type: details.payment_type,
            }
            return axios.get(URLS.TARIFFS, context.getters.request_params(params)).then(response => {
                context.commit('setElectricTariffs', response.data.Result.tariffs);
            }).catch(error => {
                handleError(error, 'getElectricTariffs', details);
            });
        },
        getDualTariffs(context, details) {
            let params = {
                supplier_id: details.supplier_id || context.state.form.dual_supplier.id,
                region_id: details.region_id || context.state.region.region_id,
                payment_type: details.payment_type || context.state.form.payment_type.id,
            }
            return axios.get(URLS.TARIFFS, context.getters.request_params(params)).then(response => {
                context.commit('setDualTariffs', response.data.Result.tariffs);
            }).catch(error => {
                handleError(error, 'getDualTariffs', details);
            });
        },


        submitSwitch(context, details) {
            if (!request_status.submitting) {
                request_status.submitting = true;
                return axios.post(URLS.QUOTE_FINAL, details, context.getters.request_params()).then(response => {
                    request_status.submitting = false;
                    if (response.data.Type === 'success') {
                        context.dispatch('submitEmail', response.data.Result.quote);
                        return true;
                    } else {
                        console.log("ERROR");
                        return false;
                    }
                }).catch(error => {
                    request_status.submitting = false;
                    handleError(error, 'submitSwitch', details);
                    Vue.set(context.state, 'form_success', false);
                });
            }
        },

        submitEmail(context, details) {
            axios.post(`${URLS.EMAIL}?EmailTo=${encodeURIComponent(details.email)}`, details, context.getters.request_params()).then(response => {
                console.log("SUCESSs", response.data);
                Vue.set(context.state, 'form_success', true);
            }).catch(error => {
                return handleError(error, 'submitEmail', details).catch(error => {
                    Vue.set(context.state, 'form_success', false);
                });
            });
        }
    },

    getters: {
        request_params: (state) => (additional = {}) => ({
            params: {
                token: state.auth.token?.value,
                ...additional
            }
        }),
        hasToken: state => state.auth.token ? true : false,
        featured_suppliers: state => state.suppliers.all.filter(supplier => {
            return FEATURED_SUPPLIERS.includes(supplier.name);
        }),
        payment_types: state => state.payment_types.all,
    }
});

let count = 1;

const handleError = (error, action, payload) => {
    if (environment.debug) {
        console.debug("debug error", error);
    }
    if (count < 5) {
        count = count + 1;
        return store.dispatch('getToken').then(() => {
            return store.dispatch(action, payload).then(() => {
                count = 1;
            });
        });
    }
}

new Vue({
    render: h => h(App),
    store: store,
    // data() {
    //     return {
    //         scripts: [
    //             { key: 'g-tag-referee', src: 'https://tag.mention-me.com/api/v2/refereefind/mmb08ad004?situation=checkout&locale=en_GB' },
    //             { key: 'g-tag', src: 'https://tag-demo.mention-me.com/api/v2/referreroffer/mmb08ad004?situation=postsignup&locale=en_GB' }
    //         ],
    //     }
    // },
    computed: {
        form() {
            return this.$store.state.form
        },
    },
    // methods: {
    //     submitSwitchReferrer() {
    //         let currentDate = new Date();
    //         const date = currentDate;
    //         const year = ('0' + (date.getFullYear())).slice(-2);
    //         const month = ('0' + (date.getMonth() + 1)).slice(-2);
    //         const day = ('0' + date.getDate()).slice(-2);
    //         const hh = ('0' + date.getHours()).slice(-2);
    //         const mm = ('0' + date.getMinutes()).slice(-2);
    //         const ss = ('0' + date.getSeconds()).slice(-2);

    //         let currentDateTime = year + '' + month + '' + day + '' + hh + '' + mm + '' + ss + '';
    //         const signupId = this.form.email.substr(0, 30) + '' + currentDateTime;
    //         let ts = this.scripts[1];
    //         axios.get(ts.src).then(response => {
    //             let key = ts.key;
    //             let script = document.createElement('script');
    //             script.type = 'application/javascript';
    //             let str = '&firstname=' + this.form.first_name + '&surname=' + this.form.last_name + '&email=' + this.form.email + '&signup_id=' + signupId;

    //             script.src = ts.src + str;
    //             if (script.readyState) { //IE
    //                 script.onreadystatechange = () => {
    //                     if (script.readyState === "loaded" || script.readyState === "complete") {
    //                         script.onreadystatechange = null;
    //                         ts.loaded = true;
    //                     }
    //                 };
    //             } else { //Others
    //                 script.onload = () => {
    //                     ts.loaded = true;
    //                 };
    //             }
    //             script.onerror = (error) => console.log("ERROR LOADING SCRIPT", error);
    //             document.getElementsByTagName('head')[0].appendChild(script);
    //         }).catch(error => {
    //             // console.log("SCRIPTERROR", error);
    //         })
    //     },

    //     mountMentionMe() {
    //         let ts = this.scripts[0];
    //         axios.get(ts.src).then(response => {
    //             let key = ts.key;
    //             let script = document.createElement('script');
    //             script.type = 'application/javascript';
    //             script.src = ts.src;
    //             if (script.readyState) { //IE
    //                 script.onreadystatechange = () => {
    //                     if (script.readyState === "loaded" || script.readyState === "complete") {
    //                         script.onreadystatechange = null;
    //                         ts.loaded = true;
    //                     }
    //                 };
    //             } else { //Others
    //                 script.onload = () => {
    //                     ts.loaded = true;
    //                 };
    //             }
    //             script.onerror = (error) => console.log("ERROR LOADING SCRIPT", error);
    //             document.getElementsByTagName('head')[0].appendChild(script);
    //         });
    //     }
    // },
    mounted() {
        //    this.mountMentionMe();
    }
}).$mount('#app')